import { gql } from "@apollo/client";

export const DETALLE_ENVIO_LOGISTICA = gql`
  query getDetalleEnvioLogistica($idEvaluacion: Int!) {
    detalleEnvioLogistica(idEvaluacion: $idEvaluacion) {
      codigoSapVenta
      fechaEntrega
      fechaRemito
      idInsumo
      descripcionInsumo
      cantidad
      uME
      tipoPedido
    }
  }
`;